// assets/animations.js

  const clamp = gsap.utils.clamp;

 function setupMarquee(rootEl, opts) {
    const track = rootEl.querySelector(".track");
    const originals = Array.from(track.children); // exactly the first 5
    const state = {
      x: 0,
      currentSpeed: 0,
      targetSpeed: 0,
      enabled: false,
      setWidth: 1,
      lastScrollSign: 1,
    };

    // 1) Ensure enough copies to cover viewport + 1 set (no gaps ever)
    function measureSetWidth() {
      const g = parseFloat(getComputedStyle(track).gap) || 0;
      // measure only the first 'originals.length' nodes
      const firstSet = Array.from(track.children).slice(0, originals.length);
      const total = firstSet.reduce((acc, el) => acc + el.offsetWidth, 0) + g * (firstSet.length - 1);
      state.setWidth = Math.max(1, total);
    }

    function ensureCopies() {
      measureSetWidth();
      const viewport = rootEl.clientWidth;
      const need = Math.max(2, Math.ceil((viewport + state.setWidth) / state.setWidth)); // viewport covered + 1 extra
      const currCopies = Math.ceil(track.children.length / originals.length);
      for (let i = currCopies; i < need; i++) {
        track.append(...originals.map(n => n.cloneNode(true)));
      }
    }

    // Wait for images (the first 5 is enough to size correctly)
    const imgs = originals.map(el => el.querySelector('img'));
    let loaded = 0;
    imgs.forEach(img => {
      if (img.complete) loaded++;
      else img.addEventListener("load", () => (++loaded === imgs.length) && init(), { once: true });
    });
    if (loaded === imgs.length) init();

    function init() {
      ensureCopies(); // initial fill

      // 2) Use modulo wrap so it NEVER "misses" the wrap on fast frames
      function wrapToPeriod(x) {
        const w = state.setWidth;
        // put x into [-w, 0)
        const wrapped = ((x % w) + w) % w; // [0, w)
        return wrapped - w;                 // [-w, 0)
      }

      // Ticker
      gsap.ticker.add((t, dt) => {
        // Smooth toward target; slow & calm
        const lerp = 1 - Math.pow(0.001, dt);
        const stopLerp = 1 - Math.pow(0.05, dt);

        if (!state.enabled) {
          state.currentSpeed += (0 - state.currentSpeed) * stopLerp;
          if (Math.abs(state.currentSpeed) < 0.02) state.currentSpeed = 0;
        } else {
          state.currentSpeed += (state.targetSpeed - state.currentSpeed) * lerp;
        }

        state.x -= state.currentSpeed * dt; // positive speed => move left
        state.x = wrapToPeriod(state.x);
        gsap.set(track, { x: state.x });
      });

      // Per-marquee ScrollTrigger to only run while in view
      ScrollTrigger.create({
        trigger: rootEl,
        start: "top bottom",
        end: "bottom top",
        onEnter() { state.enabled = true; },
        onEnterBack() { state.enabled = true; },
        onLeave() { state.enabled = false; },
        onLeaveBack() { state.enabled = false; },
        onUpdate(self) {
          if (!state.enabled) return;
          const v = self.getVelocity(); // px/s
          const sign = v === 0 ? state.lastScrollSign : Math.sign(v);
          state.lastScrollSign = sign;

          const mag = clamp(0, 200, Math.abs(v));                  // gentle cap
          const extra = gsap.utils.mapRange(0, 200, 0, opts.maxBoost)(mag);
          const dir = (sign || 1) * (opts.opposite ? -1 : 1);

          state.targetSpeed = dir * (opts.baseSpeed + extra);

          if (Math.abs(v) < 10) {
            state.targetSpeed = dir * opts.baseSpeed;
          }
        }
      });

      // Keep coverage on resize & reset phase cleanly
      const onResize = () => {
        ensureCopies();
        gsap.set(track, { x: 0 });
        state.x = -1;     // tiny offset so we see motion immediately
        state.x = ((state.x % state.setWidth) + state.setWidth) % state.setWidth - state.setWidth;
      };
      window.addEventListener("resize", onResize, { passive: true });
    }
  }


function whenGSAPReady(callback) {
  if (typeof gsap !== "undefined") {
    callback();
  } else {
    setTimeout(() => whenGSAPReady(callback), 50);
  }
}
